import { useTranslation } from "react-i18next";
import { useFeatureToggle, useModal } from "@hooks";
import { H2, P } from "@quarks";
import { CardProps, TwoColumnCell } from "@atoms";
import { ProfileCard, ProfileCell } from "../styles";
import { useGeneralExtraServices } from "@lib/logic";
import { AllExtraServicesSelectionCard } from "../../extras";
import { StyledClickableCellWrapper } from "../EmailNotificationCell/styles";
import { StyledIcon } from "../BookingPreferencesCell/styles";
import { pxToRem } from "@utils";

export const ExtraServicesCard = (props: CardProps) => {
  const { totalServicesCount } = useGeneralExtraServices(new Date().toISOString());
  const { t } = useTranslation();
  const { addPages, openModal } = useModal();

  const { ExtrasFeature: isExtrasFeatureEnabled } = useFeatureToggle();

  if (!isExtrasFeatureEnabled || !totalServicesCount) return <></>;

  const handleOnClick = () => {
    addPages([
      <AllExtraServicesSelectionCard
        category="General"
        locationName={undefined}
        meetingId={undefined}
        selectedDate={undefined}
      />,
    ]);
    openModal();
  };

  return (
    <ProfileCard
      as="section"
      {...props}>
      <H2>{t("Services")}</H2>
      <ProfileCell>
        <StyledClickableCellWrapper onClick={handleOnClick}>
          <TwoColumnCell
            padding="small"
            alignItems="center"
            left={<P>{t("AddServicesExtended")}</P>}
            right={
              <StyledIcon
                icon="caretRight"
                size={pxToRem(24)}
              />
            }
          />
        </StyledClickableCellWrapper>
      </ProfileCell>
    </ProfileCard>
  );
};
